import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Checkbox = styled.input.attrs({
  className: "checkbox",
  type: "checkbox"
})`
  appearance: none;
  -webkit-appearance: none;
  background: white;
  border: 1px solid #cccece;
  border-radius: 1px;
  cursor: pointer;
  padding: 7px;
  position: relative;

  &:checked {
    background: #194fa1;
    border-color: #194fa1;
  }
  &:checked::after {
    background: url("/assets/images/icon-checkmark.svg") no-repeat center center;
    background-size: 8px;
    content: " ";
    filter: brightness(2.5);
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  _:-ms-lang(x),
  &:checked {
    border-color: #cccece;
    padding: initial;
  }
`;
Checkbox.displayName = "Checkbox";

const Label = styled.label.attrs({ className: "checkbox-label" })`
  cursor: pointer;
  display: flex;
  & .checkbox {
    margin: 0 8px 0 0;
  }
`;
Label.displayName = "CheckboxLabel";

const UICheckbox = ({ label, labelProps, ...rest }) => {
  if (label) {
    return (
      <Label {...labelProps}>
        <Checkbox {...rest} />
        {label}
      </Label>
    );
  }

  return <Checkbox {...rest} />;
};

UICheckbox.propTypes = {
  label: PropTypes.string,
  labelProps: PropTypes.object
};

export default UICheckbox;
